import Main from './ChurnsMain'
import Create from './ChurnsCreate'
import Edit from './ChurnsEdit'
import Show from './ChurnsShow'

const Churns = {
  Main,
  Create,
  Edit,
  Show,
}

export default Churns
